const toastLayout = `
<div class="border_back_wrapper">
  <div class="border_popup_bg_wrapper">
    <div class="border_popup_bg"></div>
  </div>
  <div class="border_popup_ltop"></div>
  <div class="border_popup_mtop"></div>
  <div class="border_popup_rtop"></div>
  <div class="border_popup_ml"></div>
  <div class="border_popup_mr"></div>
  <div class="border_popup_lbot"></div>
  <div class="border_popup_mbot"></div>
  <div class="border_popup_rbot"></div>
</div>
<div class="toast-message__content">
  <div class="info-icon-22 toast-message__icon"></div>
  <div class="toast-message__text"></div>
</div>
`;

/**
 * @description
 * ToastMessage - A component for displaying temporary notification messages to users.
 *
 * This class creates and manages a toast notification element that can be used to show
 * short-lived messages to users. The toast appears as a small popup with an icon and text,
 * and automatically disappears after a specified duration.
 *
 * @limitations
 * - Requires DOM to be fully loaded before initialization. Initialization is delayed until then
 * - Only one toast message can be displayed at a time. Text is swapped if another message is shown
 *   before the previous one disappears.
 */
class ToastMessage {
    private element: HTMLElement | null = null;
    private textElement: HTMLElement | null = null;
    private timeoutId: number | null = null;
    private initialized: boolean = false;

    constructor() {
        this.init();
    }

    private init(): void {
        if (!this.element) {
            this.element = document.createElement('div');
            this.element.className = 'toast-message';
            this.element.innerHTML = toastLayout;

            $(() => {
                document.body.appendChild(this.element);
                this.textElement = this.element.querySelector('.toast-message__text');
                this.initialized = true;
            });
        }
    }

    public show(message: string, duration: number = 3000): void {
        if (!this.initialized) {
            console.error('ToastMessage is not initialized');
            return;
        }

        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }

        if (this.textElement) {
            this.textElement.textContent = message;
        }

        if (this.element) {
            this.element.classList.add('toast-message--visible');
        }

        clearTimeout(this.timeoutId);
        this.timeoutId = window.setTimeout(() => {
            this.hide();
        }, duration);
    }

    public hide(): void {
        if (!this.initialized) {
            console.error('ToastMessage is not initialized');
            return;
        }

        if (this.element) {
            this.element.classList.remove('toast-message--visible');
        }
        this.timeoutId = null;
    }
}

export const toastMessage = new ToastMessage();
